module.exports = __webpack_public_path__ + "static/media/HDFC.8807fb24.png";